/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */


import { Properties, PublicProperties } from '@api/model';
import { IAction } from '../../models/IshAction';
import { FULFILLED } from './ActionUtils';

export const GET_SYSTEM_PROPERTIES = 'GET_SYSTEM_PROPERTIES';
export const GET_SYSTEM_PROPERTIES_FULFILLED = FULFILLED(GET_SYSTEM_PROPERTIES);

export const GET_PUBLIC_PROPERTIES = 'GET_PUBLIC_PROPERTIES';
export const GET_PUBLIC_PROPERTIES_FULFILLED = FULFILLED(GET_PUBLIC_PROPERTIES);

export const getPublicProperties = (): IAction => ({
  type: GET_PUBLIC_PROPERTIES
});

export const getPublicPropertiesFulfilled = (props: PublicProperties): IAction => ({
  type: GET_PUBLIC_PROPERTIES_FULFILLED,
  payload: props
});

export const getSystemProperties = (): IAction => ({
  type: GET_SYSTEM_PROPERTIES
});

export const getSystemPropertiesFulfilled = (props: Properties): IAction => ({
  type: GET_SYSTEM_PROPERTIES_FULFILLED,
  payload: props
});